module.exports = __webpack_public_path__ + "img/logo_white.f942cde2.png";